const initialState = {
  pseudo: false,
  avatar: false,
  sid: false,
  staff: 0,
  vip: {
    plan: 0,
    remain: 0,
    canTrial: false,
    canResync: false
  },
  listener: true,
  uid: false
};

export const infos = (state = initialState, action) => {
  switch (action.type) {
    case 'INIT_SET_INFOS': {
      return {
        ...state,
        ...action.infos
      };
    }
    case 'INIT_SET_UID': {
      return {
        ...state,
        uid: action.uid
      }
    }
    case 'INFOS_SET_LISTENER': {
      return {
        ...state,
        listener: action.state
      }
    }
    case 'ADD_TRIAL': {
      return {
        ...state,
        vip: {
          ...state.vip,
          plan: state.vip.plan < 2 ? 2 : state.vip.plan,
          remain: state.vip.plan < 2 ? 86400 : state.vip.remain,
          canTrial: false
        }
      }
    }
    case 'RESYNC': {
      return {
        ...state,
        vip: {
          ...state.vip,
          canResync: false
        }
      }
    }
    case 'UPDATE_VIP': {
      if (state.vip.plan > action.plan) return state;
      var remain = 0;
      if (state.vip.plan === action.plan) remain = state.vip.remain;
      remain += action.remain;
      return {
        ...state,
        vip: {
          plan: action.plan,
          remain: remain
        }
      }
    }
    default:
      return state;
  }
};
